import Log from '@/classes/debug/Log'
import formApi from '@/api/form/formApi'
import confirmationApi from '@/api/confirmation/confirmationApi'
import FormDescriptor from '@/classes/form/FormDescriptor'
import FormData from '@/classes/form/FormData'
import Service from '@/classes/case/Service'

const state = {
  title: '',
  description: '',
  layout: {},
  formDescriptors: [],
  formDatas: [],
  service: {}
}

const mutations = {
  setStateTitle: (state, data) => {
    state.title = data
  },
  setStateDescription: (state, data) => {
    state.description = data
  },
  setStateLayout: (state, data) => {
    state.layout = data
  },
  setStateFormDescriptors: (state, data) => {
    state.formDescriptors = FormDescriptor.asFormDescriptors(data)
  },
  setStateFormDatas: (state, data) => {
    state.formDatas = FormData.initiateFormDatas(state.formDescriptors)
    FormData.loadInitialFormDatas(data, state.formDatas)
    FormDescriptor.checkFormDescriptorsDependencies(state.formDescriptors, state.formDatas)
  },
  setStateService: (state, data) => {
    state.service = Service.asService(data)
  }
}

const actions = {
  setupApplicationForm ({ commit }, code) {
    return formApi.getApplicationForm(code).then((response) => {
      let data = response.data[0]
      commit('setStateTitle', data.title)
      commit('setStateDescription', data.description)
      commit('setStateLayout', data.layout)
      commit('setStateFormDescriptors', data.forms)
      commit('setStateFormDatas', data.form_data)
      commit('setStateService', data.service)
      return true
    }).catch((err) => {
      Log.debug('Unable to receive Form descriptor for ' + code, err)
      throw err
    })
  },
  setupApplicationFormAsCustomer ({ commit }, code) {
    return formApi.getApplicationFormAsCustomer(code).then((response) => {
      let data = response.data[0]
      let formDatas = []
      for (let [index, form] of data.forms.entries()) {
        form.id = index
        formDatas.push(form.form_data)
      }
      commit('setStateTitle', data.title)
      commit('setStateDescription', data.description)
      commit('setStateLayout', data.layout)
      commit('setStateFormDescriptors', data.forms)
      commit('setStateFormDatas', formDatas)
      commit('setStateService', data.service)
      return true
    }).catch((err) => {
      Log.debug('Unable to receive Form descriptor for ' + code, err)
      throw err
    })
  },
  saveApplicationForm ({ commit }, requestData) {
    return formApi.postApplicationFormAsGuest(requestData.data.service.code, requestData.serializedData).then((response) => {
      return response
    }).catch((err) => {
      throw err
    })
  },
  saveApplicationFormAsCustomer ({ commit }, requestData) {
    return formApi.postApplicationFormAsCustomer(requestData.data.service.code, requestData.serializedData).then((response) => {
      return response
    }).catch((err) => {
      throw err
    })
  },
  setupConfirmationForm ({ commit }, code) {
    return confirmationApi.getConfirmationForm(code).then((response) => {
      let data = response.data
      commit('setStateFormDescriptors', [data])
      commit('setStateFormDatas', [])
      return true
    }).catch((err) => {
      throw err
    })
  },
  saveConfirmationForm ({ commit }, requestData) {
    return confirmationApi.postConfirmationForm(requestData.data.code, requestData.serializedData).then((response) => {
      return response
    }).catch((err) => {
      throw err
    })
  },
  clearData ({ commit }) {
    commit('setStateTitle', '')
    commit('setStateDescription', '')
    commit('setStateLayout', {})
    commit('setStateFormDescriptors', [])
    commit('setStateFormDatas', [])
    commit('setStateService', {})
  },
  getPostalCodeSuggestions ({ commit }, requestData) {
    return confirmationApi.getPostalCodeSuggestions(requestData).then((response) => {
      return response.data.result
    }).catch((err) => {
      throw err
    })
  }
}

export default {
  state,
  mutations,
  actions
}
